"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var elmer_common_1 = require("elmer-common");
var ElmerWorkerCore_1 = require("./ElmerWorkerCore");
var StaticFunc_1 = require("./StaticFunc");
var ElmerWorker = (function (_super) {
    __extends(ElmerWorker, _super);
    function ElmerWorker(props) {
        var _this = _super.call(this) || this;
        _this.props = props;
        _this.listener = {};
        _this.promiseData = {};
        _this.createWorker();
        _this.bindEvent();
        return _this;
    }
    ElmerWorker.prototype.callMethod = function (methodName) {
        var _this = this;
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            var id = _this.getRandomID();
            _this.sendMsg({
                data: params,
                id: id,
                method: methodName,
                type: "CallMethod"
            });
            _this.promiseData[id] = {
                reject: reject,
                resolve: resolve
            };
        });
    };
    ElmerWorker.prototype.callObjMethod = function (objKey, methodName) {
        var _this = this;
        var params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            params[_i - 2] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            var id = _this.getRandomID();
            _this.sendMsg({
                data: params,
                id: id,
                method: methodName,
                obj: objKey,
                type: "CallObjMethod"
            });
            _this.promiseData[id] = {
                reject: reject,
                resolve: resolve
            };
        });
    };
    ElmerWorker.prototype.addFunc = function (globalName, fn) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var id = _this.getRandomID();
            _this.sendMsg({
                data: StaticFunc_1.funcToStr(fn),
                globalName: globalName,
                id: id,
                type: "InitFunction"
            });
            _this.promiseData[id] = {
                reject: reject,
                resolve: resolve
            };
        });
    };
    ElmerWorker.prototype.addObject = function (globalName, obj) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var id = _this.getRandomID();
            _this.sendMsg({
                data: StaticFunc_1.objectToWorkerData(obj),
                globalName: globalName,
                id: id,
                type: "InitObject"
            });
            _this.promiseData[id] = {
                reject: reject,
                resolve: resolve
            };
        });
    };
    ElmerWorker.prototype.dispose = function () {
        this.worker.terminate();
        this.worker = null;
    };
    ElmerWorker.prototype.on = function (eventName, callBack) {
        this.listener[eventName] = callBack;
    };
    ElmerWorker.prototype.getInitPropsCode = function () {
        var result = "";
        if (this.props) {
            for (var key in this.props) {
                var tmpValue = this.props[key];
                if (this.isObject(tmpValue)) {
                    result += "var " + key + " = " + StaticFunc_1.objectToWorkerCode(this.props[key], key) + "\r\n";
                }
                else if (this.isNumeric(tmpValue)) {
                    result += "var " + key + " = " + tmpValue + ";\r\n";
                }
                else if (this.isFunction(tmpValue)) {
                    tmpValue = tmpValue.toString();
                    result += "var " + key + " = " + tmpValue + ";\r\n";
                }
                else if (this.isArray(tmpValue) || this.isString(tmpValue)) {
                    tmpValue = JSON.stringify(tmpValue);
                    result += "var " + key + " = " + tmpValue + ";\r\n";
                }
                else if (this.isRegExp(tmpValue)) {
                    tmpValue = tmpValue.source;
                    result += "var " + key + " = " + tmpValue + ";\r\n";
                }
                else {
                    throw new Error("不支持的数据类型");
                }
            }
        }
        return result;
    };
    ElmerWorker.prototype.createWorker = function () {
        var myBlob = new Blob([this.initBlobCode()]);
        this.worker = new Worker(window.URL.createObjectURL(myBlob));
    };
    ElmerWorker.prototype.bindEvent = function () {
        this.worker.addEventListener("message", this.message.bind(this));
        this.worker.addEventListener("error", this.error.bind(this));
    };
    ElmerWorker.prototype.error = function (err) {
        if (typeof this.listener.message === "function") {
            var eventData = {
                cancel: false,
                message: err.message,
                srcEvent: err
            };
            this.listener.message(eventData);
            if (eventData.cancel) {
                return;
            }
        }
    };
    ElmerWorker.prototype.message = function (event) {
        var data = event.data;
        var id = data.id;
        if (typeof this.listener.message === "function") {
            var eventData = {
                cancel: false,
                data: event.data,
                srcEvent: event
            };
            this.listener.message(eventData);
            if (eventData.cancel) {
                return;
            }
        }
        if (data.type === "CallMethod" || data.type === "CallObjMethod") {
            if (this.promiseData[id]) {
                var methodResponse = data;
                if (methodResponse.statusCode === 200) {
                    this.promiseData[id].resolve(methodResponse);
                }
                else {
                    this.promiseData[id].reject(methodResponse);
                }
                delete this.promiseData[id];
            }
            else {
                typeof this.listener.callMethodResponse === "function" && this.listener.callMethodResponse({
                    cancel: false,
                    data: data,
                    srcEvent: event
                });
            }
        }
        else if (data.type === "InitObject" || data.type === "InitFunction") {
            if (this.promiseData[id]) {
                var initResponse = data;
                if (initResponse.statusCode === 200) {
                    this.promiseData[id].resolve(initResponse);
                }
                else {
                    this.promiseData[id].reject(initResponse);
                }
                delete this.promiseData[id];
            }
            else {
                typeof this.listener.initResponse === "function" && this.listener.initResponse({
                    cancel: false,
                    data: data,
                    srcEvent: event
                });
            }
        }
    };
    ElmerWorker.prototype.sendMsg = function (msg) {
        this.worker.postMessage(msg);
    };
    ElmerWorker.prototype.initBlobCode = function () {
        var strToFuncCode = StaticFunc_1.strToFunc.toString();
        var coreCode = StaticFunc_1.objectToWorkerCode(new ElmerWorkerCore_1.ElmerWorkerCore(), "ElmerWorkerCore");
        var staticCode = StaticFunc_1.classToWorkerCode(elmer_common_1.StaticCommon);
        var code = [];
        code.push("var strToFunc = " + strToFuncCode);
        code.push("var __spreadArrays = " + StaticFunc_1.funcToStr(StaticFunc_1.__spreadArrays));
        code.push("var workerDataToObject = " + StaticFunc_1.funcToStr(StaticFunc_1.workerDataToObject));
        code.push("var utils = " + staticCode);
        code.push("var elmer = " + coreCode);
        code.push(this.getInitPropsCode());
        code.push("onmessage = " + StaticFunc_1.funcToStr(StaticFunc_1.onmessage));
        return code.join("\r\n");
    };
    return ElmerWorker;
}(elmer_common_1.Common));
exports.ElmerWorker = ElmerWorker;
